/**
 * Counter Station Page
 * KDS display for counter to assemble orders
 * Uses shared KDSStationLayout with auto-reconnect and offline caching
 */
import { Package } from 'lucide-react';
import KDSStationLayout from '@/components/kds/KDSStationLayout';

export default function CounterStationPage() {
  return (
    <KDSStationLayout
      station="counter"
      stationName="Counter Station"
      stationIcon={Package}
      iconColorClass="bg-gradient-to-br from-purple-500 to-purple-600"
      defaultDeviceId="KDS-CTR-01"
    />
  );
}
